import styled from 'styled-components';

export const ConsumptionContainer = styled.div`
  .ant-tabs-tab {
    margin: 0 20px 0 0;
    padding: 12px 10px;
    border-bottom: none !important;
  }

  .top-consumers-tabs .ant-tabs-tab-active {
    background: ${({ theme }) => theme.colors.background} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;

    .ant-typography {
      color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
`;
